import React from "react";
import { Navigate } from "react-router-dom";
import { UNAUTHORIZED_ACCESS } from "config/paths";
import { useUserPermissions } from "hooks/usePermissions";
import Unauthorized from "pages/SideTabPages/UnauthorizedAccess/Index";

const ProtectedRoute = ({ module, action = "view", children }) => {
  const { hasPermission } = useUserPermissions();

  if ((module && action) && !hasPermission(module, action)) {
    return <Unauthorized />
  }

  return children;
};

export default ProtectedRoute;